export default {
    name: 'ImplementationWidgetSegment',
    props: {
        label: {
            type: String,
            required: true
        }
    }
};
